import React from 'react';

const Card = ({ children, className, ...props }) => {
  return <div className={`mui-card${className ? ` ${className}` : ''}`} {...props}>{children}</div>;
};

export default Card;
